import { Resource } from 'Workspace/ResourceProvider/resourceTypes';

const CitrixBrowserResourceID = '00000000-0000-0000-0000-9.Workspace.Browser';

export function isCitrixBrowserApp(resource: Resource): Boolean {
	// SPA prepends the customer ID to the constant resource ID.
	// Hence performing "endsWith" comparison.
	return resource.id != null && resource.id.endsWith(CitrixBrowserResourceID);
}
